class Repository {
    constructor(endpoint) {
        this.endpoint = endpoint;
    }

    remove(id, request) {
        return axios.delete(this.endpoint + "/" + id, request);
    }

    index(request) {
        return axios.get(this.endpoint, request);
    }

    show(id, request) {
        return axios.get(this.endpoint + "/" + id, request);
    }

    store(payload, request) {
        return axios.post(this.endpoint, payload, request);
    }

    update(id, payload, request) {
        return axios.put(this.endpoint + "/" + id, payload, request);
    }

    simulate(id, request) {
        return axios.get(this.endpoint + "/" + id + "/simulate", request);
    }

    activate(id, payload, request) {
        return axios.put(
            this.endpoint + "/" + id + "/activate",
            payload,
            request
        );
    }
}

module.exports = Repository;
